<template>
  <img width="200px" alt="Vue logo" src="https://zokastech.com/assets/img/logo.svg">
  <GenerateText msg="Zokastech IntelliGenText" />
</template>

<script>
import GenerateText from './components/GenerateText.vue'

export default {
  name: 'App',
  components: {
    GenerateText
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
